// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button[data-v-0a7098e8]:disabled{cursor:not-allowed;pointer-events:all!important}", ""]);
// Exports
module.exports = exports;
